import { clsx } from "clsx";
import {
  CopyToClipboard,
  KeyValueList,
  NoData,
  RenderWhen
} from "../../../../../components";
import { KeyValueItem } from "../../../../../components/key-value/KeyValueList";
import Typography from "../../../../../components/typography/Typography";
import { getCampaignInfo } from "../utils";
import ExpandableValue from "../ExpandableValue";
import { Campaign } from "../../../@types/actor";
import styles from "../ioc.module.scss";

interface CampaignEntryProps {
  campaign: Campaign;
}

const CampaignEntry = ({ campaign }: CampaignEntryProps) => {
  const hashes = campaign?.iocs
    ?.filter(ioc =>
      ["file-hash-sha1", "file-hash-sha256", "file-hash-md5"].includes(ioc.type)
    )
    .map(ioc => ioc.value.toLowerCase())
    .join(", ");

  const urls = getCampaignInfo(campaign, "url");
  const ips = getCampaignInfo(campaign, "ip-address");
  const domains = getCampaignInfo(campaign, "domain");

  return (
    <div className={styles.campaign_ioc_body}>
      <KeyValueItem
        label="Techniques: "
        value={
          <ExpandableValue
            value={campaign?.ttps?.map(tactic => tactic.name).join(", ")}
            fallback={<NoData />}
          />
        }
      />
      <Typography variant="subtitle4" className={styles.campaign_ioc_title}>
        IOCs:
      </Typography>
      <KeyValueList className={styles.ioc_key_value_entry}>
        <KeyValueList.Item
          label="Hashes: "
          value={
            <RenderWhen condition={!!hashes} fallback={<NoData />}>
              <CopyToClipboard value={hashes} className="m-right-1" />
              <ExpandableValue
                value={<span className={styles.indented_inline}>{hashes}</span>}
              />
            </RenderWhen>
          }
          className={clsx(styles.campaign_iocs_bullet, "inline-flex")}
        />
        <KeyValueList.Item
          label="URLs: "
          value={
            <RenderWhen condition={!!urls} fallback={<NoData />}>
              <CopyToClipboard value={urls} className="m-right-1" />
              <ExpandableValue
                value={<span className={styles.indented_inline}>{urls}</span>}
              />
            </RenderWhen>
          }
          className={clsx(styles.campaign_iocs_bullet, "inline-flex")}
        />
        <KeyValueList.Item
          label="IPs: "
          value={
            <RenderWhen condition={!!ips} fallback={<NoData />}>
              <CopyToClipboard value={ips} className="m-right-1" />
              <ExpandableValue
                value={<span className={styles.indented_inline}>{ips}</span>}
              />
            </RenderWhen>
          }
          className={clsx(styles.campaign_iocs_bullet, "inline-flex")}
        />
        <KeyValueList.Item
          label="Domains: "
          value={
            <RenderWhen condition={!!domains} fallback={<NoData />}>
              <CopyToClipboard value={domains} className="m-right-1" />
              <ExpandableValue
                value={
                  <span className={styles.indented_inline}>{domains}</span>
                }
              />
            </RenderWhen>
          }
          className={clsx(styles.campaign_iocs_bullet, "inline-flex")}
        />
      </KeyValueList>
    </div>
  );
};

export default CampaignEntry;
